import { DEFAULT_DOCUMENT_TITLE, DEFAULT_META_DESCRIPTION } from './defaultDocumentMeta';

/**
 * 静的ページ（記事詳細以外）のタブタイトル・meta description。
 * ビルド時プリレンダ `scripts/prerender-html.mjs` の STATIC_PAGE_META と文言を同期すること。
 */
export const STATIC_PAGE_META: Record<string, { title: string; description: string }> = {
  '/': {
    title: DEFAULT_DOCUMENT_TITLE,
    description: DEFAULT_META_DESCRIPTION,
  },
  '/articles': {
    title: '旅行コラム | Social Trip',
    description:
      '旅行のヒントやおすすめスポットなど、SOCIAL TRIP のコラム記事を一覧でご覧いただけます。',
  },
  '/diagnosis': {
    title: '旅行スタイル診断 | Social Trip',
    description:
      'いくつかの質問に答えるだけで、あなたに合った旅のスタイルを診断します。',
  },
  '/contact': {
    title: 'お問い合わせ | Social Trip',
    description: 'SOCIAL TRIP へのお問い合わせはこちらから。',
  },
  '/privacy': {
    title: 'プライバシーポリシー | Social Trip',
    description: 'SOCIAL TRIP のプライバシーポリシーです。',
  },
  '/terms': {
    title: '利用規約 | Social Trip',
    description: 'SOCIAL TRIP の利用規約です。',
  },
};

const DIAGNOSIS_RESULT_DESCRIPTION =
  '旅行スタイル診断の結果です。あなたにおすすめの旅の楽しみ方をご覧ください。';

for (let i = 1; i <= 17; i++) {
  const path = i === 1 ? '/diagnosis-result' : `/diagnosis-result${i}`;
  STATIC_PAGE_META[path] = {
    title: '診断結果 | Social Trip',
    description: DIAGNOSIS_RESULT_DESCRIPTION,
  };
}

/** 記事詳細パス `/articles/:id`（一覧 `/articles` は含まない） */
export function isArticleDetailPath(pathname: string): boolean {
  return /^\/articles\/[^/]+\/?$/.test(pathname);
}

/** 未登録ルート用（404 相当のクライアント遷移） */
export const NOT_FOUND_PAGE_META = {
  title: 'ページが見つかりません | Social Trip',
  description: 'お探しのページは見つかりませんでした。',
};

/** パス正規化（末尾スラッシュ除去・ルート以外） */
export function normalizePathname(pathname: string): string {
  if (pathname !== '/' && pathname.endsWith('/')) {
    return pathname.replace(/\/+$/, '');
  }
  return pathname;
}

export function getStaticPageMeta(
  pathname: string
): { title: string; description: string } | null {
  const key = normalizePathname(pathname);
  return STATIC_PAGE_META[key] ?? null;
}
